import { render, staticRenderFns } from "./KintaiPatternCardList.vue?vue&type=template&id=510ceaa8&scoped=true&"
import script from "./KintaiPatternCardList.vue?vue&type=script&lang=ts&"
export * from "./KintaiPatternCardList.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiPatternCardList.vue?vue&type=style&index=0&id=510ceaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ceaa8",
  null
  
)

export default component.exports